import React, { useEffect } from 'react'
import { MuiGrid } from '../../../ui/MaterialUIComponents';
import TimeTableGridComponent from './TimeTableGridComponent'
import TimeTableToolBar from './TimeTableToolBar'
import { makeStyles } from '@material-ui/core/styles';
import { evalLicenseToShowText,calculateBlur } from '../../../../utils/EvaluationUtil'
import { getTimeTableSlotsForExcel, getTeacherTimeTableSlotsForExcel } from './GenerateTimeTableExcelUtil'
import '../../../ui/scrollbarForLog.css'
import IndividualTimeTableForClass from './IndividualTimeTableForClass';
import theme from '../../../../assests';
const useStyles = makeStyles(theme => ({
    root: {},
    spacingGrid: { height: '2vh' },
    timeTableGrid: { marginLeft: 8, height: '65vh', width: '100%' }
}));
export default function TimeTableComponent(props) {

    //const [gradeLevel, setGradeLevel] = React.useState(props.location.state.schedule.weeklyCalendar[0].calendarName);
    const [timeTableType, setTimeTableType] = React.useState('forClass');
    const [scheduleType, setScheduleType] = React.useState('masterSchedule');
    const [dataSet, setDataSet] = React.useState([]);
    const [columnData, setColumnData] = React.useState([]);
    //const [periodData, setPeriodData] = React.useState([]);
    const [cellData, setCellData] = React.useState([]);
    const [dayHeaderForIndividual, setdayHeaderForIndividual] = React.useState([]);
    const [sheetName, setSheetName] = React.useState("");
    //const [header, setHeader] = React.useState([]);

    const classes = useStyles();
    let timeTableForTeacher = {}
    let calendars = {}
    let timeTable = {}
    let availableTeachersList = []
    let roomsTimeTable = []
    let lastHourSlot = null;
    let startHourSlot = null;
    let percentage = props.activeSchool.license.status == 'Trial period' ? props.systemConfig.enableBlurForTrialUser? (props.systemConfig.timetableDisplayPercentage / 100) : 1 : 1


    const i18n = props.i18n
    let days = [{ code: 'su', "name": i18n.days.SUNDAY, index: 0 },
    { code: 'mo', "name": i18n.days.MONDAY, index: 1 },
    { code: 'tu', "name": i18n.days.TUESDAY, index: 2 },
    { code: 'we', "name": i18n.days.WEDNESDAY, index: 3 },
    { code: 'th', "name": i18n.days.THURSDAY, index: 4 },
    { code: 'fr', "name": i18n.days.FRIDAY, index: 5 },
    { code: 'sa', "name": i18n.days.SATURDAY, index: 6 }]
    let schedule = {}
    if (props.location.state && props.location.state.schedule != undefined) {
        timeTableForTeacher = props.location.state.schedule.timeTableDetails.timeTableForTeacher
        calendars = props.location.state.schedule.weeklyCalendar[0].periodsDetails
        timeTable = props.location.state.schedule.timeTableDetails.timeTable;
        availableTeachersList = props.location.state.schedule.timeTableDetails.availableTeachersList
        roomsTimeTable = props.location.state.schedule.timeTableDetails.roomsTimeTable
        lastHourSlot = props.location.state.schedule.weeklyCalendar[0].lastHourSlot
        startHourSlot = props.location.state.schedule.weeklyCalendar[0].startHourSlot
        schedule = props.location.state.schedule
    }
    else {
        availableTeachersList = props.schedule.timeTableDetails.availableTeachersList
        timeTableForTeacher = props.schedule.timeTableDetails.timeTableForTeacher
        calendars = props.schedule.weeklyCalendar[0].periodsDetails
        timeTable = props.schedule.timeTableDetails.timeTable;
        roomsTimeTable = props.schedule.timeTableDetails.roomsTimeTable
        lastHourSlot = props.schedule.weeklyCalendar[0].lastHourSlot
        startHourSlot = props.schedule.weeklyCalendar[0].startHourSlot
        schedule = props.schedule
    }
    let noOfTimeTableToShowIndex = calculateBlur(percentage, timeTable, props.systemConfig.maxNumberOfItemDisplayForTrialUser)
    let noOfTimeTableForTeacherToShowIndex = calculateBlur(percentage, timeTableForTeacher, props.systemConfig.maxNumberOfItemDisplayForTrialUser)
    let noOfRoomsTimeTableToShowIndex = calculateBlur(percentage, timeTableForTeacher, props.systemConfig.maxNumberOfItemDisplayForTrialUser)
    // const handleChange = event => {

    //     let exist = false
    //     if (props.location.state.schedule.timeTableDetails.weeklyTimeTableHeader.length > 1) {
    //         props.location.state.schedule.timeTableDetails.weeklyTimeTableHeader.map(function (header, index) {

    //             if ((header.level).toLowerCase() == event.target.value) { setHeader(props.location.state.schedule.weeklyCalendar[0].periodsDetails); exist = true; }
    //             else if (exist == false && props.location.state.schedule.timeTableDetails.weeklyTimeTableHeader.length - 1 == index) {
    //                 setHeader([])
    //             }
    //         })
    //     }
    //     setGradeLevel(event.target.value);

    // };
    // const setData = () => {
    //     if (props.location.state.schedule.timeTableDetails.weeklyTimeTableHeader.length > 1) {
    //         setGradeLevel(props.location.state.schedule.timeTableDetails.weeklyTimeTableHeader[0].level.toLowerCase())
    //         setHeader(props.location.state.schedule.weeklyCalendar[0].periodsDetails)

    //     }
    //     else {

    //         setHeader(props.location.state.schedule.weeklyCalendar[0].periodsDetails)
    //     }

    // };
    // useEffect(() => {
    //     setData();
    // }, []);

    const handleChangeTimeTableType = event => {
        setTimeTableType(event.target.value);
        let temp = []
        setDataSet([])
        setCellData([])
        setColumnData([])
    };
    const handleChangeScheduleType = event => {
        ;
        setScheduleType(event.target.value);
        setDataSet([])
        setCellData([])
        setColumnData([])
    };
    function showText(name, timeTableType, index) {
        switch (timeTableType) {
            case 'forClass': return evalLicenseToShowText(name, noOfTimeTableToShowIndex, index)
                break;
            case 'forTeacher': return evalLicenseToShowText(name, noOfTimeTableForTeacherToShowIndex, index)
                break;
            case 'forRooms': return evalLicenseToShowText(name, noOfRoomsTimeTableToShowIndex, index)
                break;
            default: return ''
        }

    }
    const showContextualHelp = (props, event) => {
        let content = props.contextualHelp["timetableResults"];
        if (content !== undefined) {
            props.toggleDrawer("right", true, content)(event)
        }
    }




    const getDay = (day1) => {
        let day = days.find((d) => d.index == day1.dayNumber)
        return day.name

    }
    const getColumnDataForIndividualTimeTable = () => {
 
        // let columnDataTemp = []
        let periodDataTemp = []
        for (let i = 0; i < calendars.length; i++) {
            columnData.push({ title: " ", width: { wpx: 200, } })
            dayHeaderForIndividual.push({
                value: getDay(calendars[i]), width: { wpx: 200, }, style: {
                    font: { sz: "11", bold: true, },
                    fill: { patternType: "solid", fgColor: { rgb: "ffededed" } },
                    alignment: { wrapText: true },
                    border: {
                        top: { style: "thin", color: "ffededed" },
                        bottom: { style: "thin", color: "ffededed" },
                        left: { style: "thin", color: "ffededed" },
                        right: { style: "thin", color: "ffededed" }
                    }
                },
            })
            // periodDataTemp.push({ value: "a", width: { wpx: 100, } })
        }


        // let cellDataTemp = cellData
        // cellDataTemp.push(periodDataTemp);
        // setCellData(cellDataTemp)

    }
    const getTeacherIndividualSchedule = (timeTable) => {
        let cellDataTemp = cellData
        
         timeTable.map(function (teacher, index2) {
             let title = teacher.firstName + " " + teacher.lastName + ' ( ' + teacher.id + ' ) ' + (teacher.groupName != undefined ? ' ( ' + i18n.commonTexts.class + ':' + teacher.groupName.toUpperCase() + ' )' : '')

            let topCell = [{
                value: i18n.weeklyTimeTable.itemTitle +" "+ title.toUpperCase(),

                style: {
                    font: { sz: "11", bold: true, },
                    fill: { patternType: "solid", fgColor: { rgb: "ffededed" } },
                    alignment: { wrapText: true },
                }
            }]
            cellDataTemp.push([{ value: "" }])
            cellDataTemp.push(topCell);
            cellDataTemp.push(dayHeaderForIndividual)

             let returnCellData = getTeacherTimeTableSlotsForExcel(teacher, calendars, days)

            for (let [k, v] of returnCellData) {

                cellDataTemp.push(v)
            }


            setCellData(cellDataTemp)



        })
    }
    const getClassIndividualSchedule = (timeTable) => {
        let cellDataTemp = cellData

        timeTable.map(function (class1, index2) {
            let topCell = [{
                value: i18n.weeklyTimeTable.itemTitle +" " + class1.name.toUpperCase(),

                style: {
                    font: { sz: "11", bold: true, },
                    alignment: { wrapText: true },
                    // border: {
                    //     top: { style: "thin", color: "ffededed" },
                    //     bottom: { style: "thin", color: "ffededed" },
                    //     left: { style: "thin", color: "ffededed" },
                    //     right: { style: "thin", color: "ffededed" }
                    // }
                }
            }]
            cellDataTemp.push([{ value: "" }])
            cellDataTemp.push(topCell);
            cellDataTemp.push(dayHeaderForIndividual)
            let returnCellData = getTimeTableSlotsForExcel(class1)

            for (let [k, v] of returnCellData) {

                cellDataTemp.push(v)
            }
            // class1.days.map(function (day1, index3) {
            //     day1.periods.map(function (period, index1) {

            //     })})

            setCellData(cellDataTemp)
            //cellDataTemp = cellData


        })
    }
    const getColumnData = () => {

        let columnDataTemp = []
        let periodDataTemp = [{ value: "", width: { wpx: 100, } }]
        columnData.push({ title: "-", width: { wpx: 60, } })
        for (let i = 0; i < calendars.length; i++) {

            for (let j = 0; j < calendars[i].periods.length; j++) {
                if (calendars[i].periods[j] != undefined) {
                    let startTime = calendars[i].periods[j].startTime_str
                    let endTime = calendars[i].periods[j].endTime_str

                    switch (calendars[i].periods[j].typeOfPeriod) {
                        case "period":
                            periodDataTemp.push({
                                value: startTime + "  " + endTime, style: {
                                    fill: { patternType: "solid", fgColor: { rgb: "ffededed" } },
                                    alignment: { wrapText: true },
                                    border: {
                                        top: { style: "thin", color: "ffededed" },
                                        bottom: { style: "thin", color: "ffededed" },
                                        left: { style: "thin", color: "ffededed" },
                                        right: { style: "thin", color: "ffededed" }
                                    }
                                }
                            })
                            // columnData = 
                            setDayCell(60, calendars[i], j, columnData)
                            // columnData.push({
                            //     title: (j == 0) ? getDay(header[i]) : "", width: { wpx: 60, }, style: {
                            //         fill: { patternType: "solid", fgColor: { rgb: "ffededed" } }
                            //     }
                            // })
                            break;
                        case "break":
                            periodDataTemp.push({
                                value: "", style: {
                                    fill: { patternType: "solid", fgColor: { rgb: "ffededed" } },
                                    alignment: { wrapText: true },
                                    border: {
                                        top: { style: "thin", color: "ffededed" },
                                        bottom: { style: "thin", color: "ffededed" },
                                        left: { style: "thin", color: "ffededed" },
                                        right: { style: "thin", color: "ffededed" }
                                    }
                                }
                            })
                            // columnData = 
                            setDayCell(10, calendars[i], j, columnData)
                            // columnData.push({
                            //     title: (j == 0) ? getDay(header[i]) : "", width: { wpx: 10, }, style: {
                            //         fill: { patternType: "solid", fgColor: { rgb: "ffededed" } }
                            //     }
                            // })
                            break;
                        case "lunch":
                            periodDataTemp.push({
                                value: "lunch", style: {
                                    fill: { patternType: "solid", fgColor: { rgb: "ffededed" } },
                                    alignment: { wrapText: true },
                                    border: {
                                        top: { style: "thin", color: "ffededed" },
                                        bottom: { style: "thin", color: "ffededed" },
                                        left: { style: "thin", color: "ffededed" },
                                        right: { style: "thin", color: "ffededed" }
                                    }
                                }

                            })
                            // columnData =
                            setDayCell(20, calendars[i], j, columnData)
                            // columnData.push({
                            //     title: (j == 0) ? getDay(header[i]) : "", width: { wpx: 20, }, style: {
                            //         fill: { patternType: "solid", fgColor: { rgb: "ffededed" } }
                            //     }
                            // })
                            break;
                    }
                }
            }

        }
        setColumnData(columnDataTemp);
        // setPeriodData(periodDataTemp)
        let cellDataTemp = cellData
        cellDataTemp.push(periodDataTemp);
        setCellData(cellDataTemp)
    }

    const setDayCell = (width, day, index, columnData) => {
        if (index == 0) {
            columnData.push({
                title: getDay(day), width: { wpx: width, }, style: {
                    fill: { patternType: "solid", fgColor: { rgb: "ffededed" } },
                    border: {
                        left: { style: "thin", color: "ffededed" },
                    }
                }
            })
        } else {
            columnData.push({
                title: "", width: { wpx: width, }, style: {
                    fill: { patternType: "solid", fgColor: { rgb: "ffededed" } }
                }
            })
        }
        return columnData
    }
    const getTimeTableData = () => {
        switch (timeTableType) {
            case "forClass":
                setSheetName("Group Master Table")
                getClassMasterSchedule(timeTable)
                break;
            case "forTeacher":
                setSheetName("Teacher Master Table")
                getTeacherMasterSchedule(timeTableForTeacher)
                break;

            case "forRooms":
                setSheetName("Room Master Table")
                getClassMasterSchedule(roomsTimeTable)
                break;;
        }
    }
    const getTimeTableDataForIndividualTimeTable = () => {
        switch (timeTableType) {
            case "forClass":
                setSheetName("Group Individual Table")
                getClassIndividualSchedule(timeTable)
                break;
            case "forTeacher":
                setSheetName("Teacher Individual Table")
                getTeacherIndividualSchedule(timeTableForTeacher)
                break;

            case "forRooms":
                setSheetName("Room Individual Table")
                getClassIndividualSchedule(roomsTimeTable)
                break;;
        }
    }
    const getTeacherMasterSchedule = (timeTable) => {
        timeTable.map(function (teacher, index2) {
            let cellDataItem = [{
                value: (teacher.id).toUpperCase(),

                style: {

                    alignment: { wrapText: true },
                    border: {
                        top: { style: "thin", color: "ffededed" },
                        bottom: { style: "thin", color: "ffededed" },
                        left: { style: "thin", color: "ffededed" },
                        right: { style: "thin", color: "ffededed" }
                    }
                }
            }]
            let cellDataTemp = cellData
            calendars.map(function (day1, index3) {
                if (day1.periods.length > 0) {
                    let teacherDay = teacher.days.find((day) => day.name == getDay(day1));
                    if (teacherDay != undefined) {
                        day1.periods.map(function (period, index1) {
                            let periodObj = teacherDay.classes.find((p) => p.period == period.periodName);
                            let colorhex8 = ''
                            let data = ''
                            if (periodObj != undefined) {
                                if (periodObj.typeOfPeriod != 'slot') {
                                    data = periodObj.subject != undefined && periodObj.subject.code != undefined && periodObj.className != undefined ? periodObj.subject.code + "-" + periodObj.className : ''
                                    let color = periodObj.color != undefined && periodObj.color != "" ? periodObj.color : '#FFFFFF'
                                    colorhex8 = color.replace("#", "ff");
                                }
                                else {
                                    colorhex8 = 'ffffffff'
                                }
                            } else {
                                if (period.typeOfPeriod != 'period') {
                                    colorhex8 = 'ffededed'
                                } else {
                                    colorhex8 = 'ffffffff'
                                }

                            }

                            cellDataItem.push({
                                value: data.toUpperCase(), style: {
                                    fill: { patternType: "solid", fgColor: { rgb: colorhex8 } },
                                    alignment: { wrapText: true },
                                    border: {
                                        top: { style: "thin", color: "ffededed" },
                                        bottom: { style: "thin", color: "ffededed" },
                                        left: { style: "thin", color: "ffededed" },
                                        right: { style: "thin", color: "ffededed" }
                                    }
                                }
                            })
                        })
                    }
                }
            })
            cellDataTemp.push(cellDataItem);
            setCellData(cellDataTemp)

        })
    }
    const getClassMasterSchedule = (timeTable) => {
        timeTable.map(function (class1, index2) {
            let cellDataItem = [{
                value: class1.name.toUpperCase(),

                style: {

                    alignment: { wrapText: true },
                    border: {
                        top: { style: "thin", color: "ffededed" },
                        bottom: { style: "thin", color: "ffededed" },
                        left: { style: "thin", color: "ffededed" },
                        right: { style: "thin", color: "ffededed" }
                    }
                }
            }]
            let cellDataTemp = cellData

            class1.days.map(function (day1, index3) {
                day1.periods.map(function (period, index1) {
                    let data = period.subject.code != undefined ? period.subject.code : ''
                    let colorhex8 = ''

                    if (period.typeOfPeriod == 'period') {
                        let color = period.subject.color != undefined && period.subject.color != "" ? period.subject.color : '#FFFFFF'
                        colorhex8 = color.replace("#", "ff");
                    } else {
                        colorhex8 = 'ffededed'
                    }


                    cellDataItem.push({
                        value: data.toUpperCase(), style: {
                            fill: { patternType: "solid", fgColor: { rgb: colorhex8 } },
                            alignment: { wrapText: true },
                            border: {
                                top: { style: "thin", color: "ffededed" },
                                bottom: { style: "thin", color: "ffededed" },
                                left: { style: "thin", color: "ffededed" },
                                right: { style: "thin", color: "ffededed" }
                            }
                        }
                    })
                })
            })
            cellDataTemp.push(cellDataItem);
            setCellData(cellDataTemp)

        })
    }
    const generateExcel = async () => {
        setDataSet([])
        setCellData([])
        setColumnData([])
        if (scheduleType == 'masterSchedule') {

            await getColumnData()
            await getTimeTableData()
        }
        else {
            await getColumnDataForIndividualTimeTable()
            await getTimeTableDataForIndividualTimeTable()
        }

        let dataSetDetails = [
            {
                columns: columnData,
                data: cellData
            }
        ];
        setDataSet(dataSetDetails)
    }
    return (
        <MuiGrid container >

            <MuiGrid container xs={12}>
                <TimeTableToolBar {...props}
                    scheduleType={scheduleType}
                    //                    gradeLevel={gradeLevel}
                    timeTableType={timeTableType}
                    // header={calendars}
                    timeTable={timeTable}
                    timeTableForTeacher={timeTableForTeacher}
                    roomsTimeTable={roomsTimeTable}
                    calendars={calendars}
                    handleChangeScheduleType={handleChangeScheduleType}
                    // handleChange={handleChange}
                    schedule={schedule}
                    handleChangeTimeTableType={handleChangeTimeTableType}
                    generateExcel={generateExcel}
                    dataSet={dataSet}
                    sheetName={sheetName}
                    showContextualHelp={showContextualHelp} />
            </MuiGrid>

            <MuiGrid container

                className={classes.spacingGrid}
            ></MuiGrid>
            <MuiGrid className={classes.timeTableGrid} id='scrollStyleWithoutDisplay'>

                <TimeTableGridComponent {...props}
                    header={calendars}
                    timeTable={timeTable}
                    timeTableForTeacher={timeTableForTeacher}
                    availableTeachersList={availableTeachersList}
                    timeTableType={timeTableType}
                    scheduleType={scheduleType}
                    roomsTimeTable={roomsTimeTable}
                    lastHourSlot={lastHourSlot}
                    startHourSlot={startHourSlot}
                    noOfTimeTableToShowIndex={noOfTimeTableToShowIndex}
                    noOfTimeTableForTeacherToShowIndex={noOfTimeTableForTeacherToShowIndex}
                    noOfRoomsTimeTableToShowIndex={noOfRoomsTimeTableToShowIndex}
                    showText={showText}
                //gradeLevel={gradeLevel}

                />
            </MuiGrid>

        </MuiGrid>
    )

}


